import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";
import { fetchWorkspacesThunk } from "app/pages/sales-intelligence/sub-modules/common/store/effects";

const useWorkspacesCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(fetchWorkspacesThunk());
    });
};

export default useWorkspacesCall;
